module.exports = __webpack_public_path__ + "img/base.2ec1bb80.png";